import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { InvoiceService } from '../../Services/invoice.service';
import { FileDownloadService } from 'src/app/services/file-download.service';
import * as moment from 'moment';

@Component({
  selector: 'app-download-onetime-pmt-report',
  templateUrl: './download-onetime-pmt-report.component.html',
  styleUrls: ['./download-onetime-pmt-report.component.less']
})
export class DownloadOnetimePmtReportComponent implements OnInit {
  public processing : boolean = false;
  invoicingMonths : number[] = [1,2,3,4,5,6,7,8,9,10,11,12];
  invoicingYears : number[] = [2020, 2021, 2022,2023,2024];
  selectedYear : number;
  selectedMonth : number;

  constructor(    
    public  modalService: NgbModal,
    public toasterService: ToastrService,
    public invoiceService: InvoiceService,
    private fileDownload: FileDownloadService) { }

  ngOnInit() {
  }


  download() : void {
    this.processing = true;
    this.invoiceService.downloadOneTimePaymentCSV(this.selectedMonth, this.selectedYear).subscribe((res : Blob) => {
      if (res) {
        this.fileDownload.HandleFileDownload(res, 'csv', `${this.selectedYear} - ${this.selectedMonth} One Time Payment Report.csv`);
        this.modalService.dismissAll();
      } else {
        this.toasterService.info('No one time payment data found.');
      }
      this.processing = false;
    },
    (err) => {
      this.toasterService.error('There was an error fetching one time payment report data.', '', { disableTimeOut: true, closeButton: true });
      this.processing = false;
    });
  }

  cancel() : void {
    this.modalService.dismissAll();
  }

  getMonthName(month:number): string{
    return moment().month(month -1).format('MMMM');
  }

}
